<script>
import table from './retailers.table'
import getExportedFilename from '@lib/utils/get-exported-filename'
import { mapGetters } from 'vuex'

export default {
  name: 'Retailers',
  page: {
    title: 'Retailers',
  },
  data() {
    return {
      table: table(this),
    }
  },
  computed: {
    ...mapGetters('me', ['canCreateRetailer']),
    customComparisons() {
      return {
        string: {
          eq: 'contains',
        },
      }
    },
  },
  methods: {
    onRowClick(row) {
      this.$router.push({
        name: 'retailer-details',
        params: { id: row.id },
      })
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="Retailers">
    <template #header>
      <el-button
        v-if="canCreateRetailer"
        type="primary"
        plain
        @click="$router.push({
          name: 'retailer-new'
        })"
      >
        + Add New Retailer
      </el-button>
    </template>
    <table-layout
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :fragments="false"
      :quantity="[25, 50, 100, 200]"
      :custom-comparisons="customComparisons"
      :export-filename="getExportedFilename"
      :multisort="false"
      hider-header-visible
      @row-click="onRowClick"
    />
  </main-layout>
</template>
